// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1761":"3b4fcaf1e79b4059","3307":"1d63a150e604a049","5384":"060787d11cea7316"}[chunkId] + ".css";
};